import { render } from "./OurClient.vue?vue&type=template&id=12f1680a"
import script from "./OurClient.vue?vue&type=script&lang=js"
export * from "./OurClient.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__